<template>
  <div class="w-full h-12 bg-white shadow-lg print:shadow-none">
    <header
      class="relative w-full h-full max-w-4xl mx-auto flex justify-center sm:justify-between items-center print:max-w-none"
    >
      <NuxtLink to="/" class="flex items-center rounded-lg">
        <div
          class="w-8 h-8 p-1 mx-2 bg-white border border-green-600 fill-green-600 stroke-white hover:border-green-500 hover:fill-green-500 focus:border-green-500 focus:fill-green-500 active:border-blue-gray-700 active:fill-blue-gray-700 rounded-full print:hidden"
        >
          <SvgHouse class="stroke-white" />
        </div>
        <div
          class="pr-2 text-xl text-green-600 hover:text-green-500 focus:text-green-500 active:text-blue-gray-700 print:pl-2"
        >
          {{ Location.locationName }}
        </div>
      </NuxtLink>
      <div
        id="menu"
        class="fixed w-15 h-15 right-4 bottom-4 p-1 bg-green-600 text-white text-xs rounded-full shadow-lg hover:bg-green-500 focus:bg-green-500 active:bg-blue-gray-700 sm:absolute sm:h-10 sm:w-10 sm:right-3 sm:bottom-1 sm:p-0 sm:rounded-lg sm:bg-white sm:text-blue-gray-800 sm:hover:bg-white sm:focus:bg-white sm:active:bg-white print:hidden"
      >
        <button
          id="menuButton"
          class="h-full w-full flex justify-center items-center border rounded-full px-3 sm:border sm:rounded-lg sm:hover:text-green-600 sm:focus-visible:text-green-600 sm:active:text-blue-gray-700 sm:active:transform sm:active:scale-[80%] sm:shadow-none"
          type="button"
          @click="menuVisible = !menuVisible"
          aria-controls="navbarSupportedContentX"
          aria-expanded="false"
          :aria-label="I18nNO.menuAria"
        >
          <span class="transform -rotate-90 -ml-[1.45rem] -mr-4">{{
            I18nNO.menu
          }}</span>
          <span v-if="menuVisible" class="ml-[0.6rem] -mr-[0.7rem] text-3xl"
            >X</span
          >
          <SvgMenu
            v-else
            aria-hidden="true"
            focusable="false"
            class="pointer-events-none w-5 ml-[0.6rem] -mr-[0.75rem]"
            role="img"
          />
        </button>
        <nav
          v-if="menuVisible"
          class="bg-glass fixed right-3 bottom-16 m-1 items-center text-base leading-tight border rounded-lg border-green-600/50 shadow-lg sm:absolute sm:-right-2 sm:top-10 sm:bottom-auto sm:rounded-t-none"
        >
          <ul class="mr-auto flex flex-col divide-y divide-green-600/20">
            <li>
              <NuxtLink
                to="/"
                @click="toggleMenu"
                class="block p-2 text-blue-gray-800 hover:text-green-600 focus:text-green-600 active:text-blue-gray-700 active:bg-green-600/50 active:animate-ping"
                >{{ I18nNO.homeLink }}</NuxtLink
              >
            </li>
            <li>
              <NuxtLink
                to="/program"
                @click="toggleMenu"
                class="block p-2 text-blue-gray-800 hover:text-green-600 focus:text-green-600 active:text-blue-gray-700 active:bg-green-600/50 active:animate-ping"
                >{{ I18nNO.calendarLink }}</NuxtLink
              >
            </li>
            <li>
              <NuxtLink
                to="/legg-til-kalender"
                @click="toggleMenu"
                class="block p-2 ml-4 text-blue-gray-800 hover:text-green-600 focus:text-green-600 active:text-blue-gray-700 active:bg-green-600/50 active:animate-ping"
                >{{ I18nNO.importCalendarLink }}</NuxtLink
              >
            </li>
            <li>
              <NuxtLink
                to="/om-oss"
                @click="toggleMenu"
                class="block p-2 text-blue-gray-800 hover:text-green-600 focus:text-green-600 active:text-blue-gray-700 active:bg-green-600/50 active:animate-ping"
                >{{ I18nNO.aboutLink }}</NuxtLink
              >
            </li>
            <li>
              <NuxtLink
                to="/aktiviteter"
                @click="toggleMenu"
                class="block p-2 ml-4 text-blue-gray-800 hover:text-green-600 focus:text-green-600 active:text-blue-gray-700 active:bg-green-600/50 active:animate-ping"
                >{{ I18nNO.activitiesLink }}</NuxtLink
              >
            </li>
            <li>
              <NuxtLink
                to="/medlemskap"
                @click="toggleMenu"
                class="block p-2 ml-4 text-blue-gray-800 hover:text-green-600 focus:text-green-600 active:text-blue-gray-700 active:bg-green-600/50 active:animate-ping"
                >{{ I18nNO.membershipLink }}</NuxtLink
              >
            </li>
            <li>
              <NuxtLink
                to="/givertjeneste"
                @click="toggleMenu"
                class="block p-2 ml-4 text-blue-gray-800 hover:text-green-600 focus:text-green-600 active:text-blue-gray-700 active:bg-green-600/50 active:animate-ping"
                >{{ I18nNO.donationsLink }}</NuxtLink
              >
            </li>
            <li>
              <NuxtLink
                to="/kart"
                @click="toggleMenu"
                class="block p-2 ml-4 text-blue-gray-800 hover:text-green-600 focus:text-green-600 active:text-blue-gray-700 active:bg-green-600/50 active:animate-ping"
                >{{ I18nNO.mapLink }}</NuxtLink
              >
            </li>
            <!-- <li>
              <NuxtLink -->
            <!-- cspell: ignore arrangorer -->
            <!-- to="/arrangorer"
                @click="toggleMenu"
                class="block p-2 ml-4 text-blue-gray-800 hover:text-green-600 focus:text-green-600 active:text-blue-gray-700 active:bg-green-600/50 active:animate-ping"
                >{{ I18nNO.organizersLink }}</NuxtLink
              >
            </li> -->
          </ul>
        </nav>
      </div>
    </header>
  </div>
</template>

<script setup lang="ts">
import Location from "@/data/Location";
import PlainI18nNO from "@/data/I18nNO";
const I18nNO = reactive(PlainI18nNO);

const menuVisible = ref(false);
const toggleMenu = () => (menuVisible.value = !menuVisible.value);

onMounted(() => {
  document.addEventListener("click", (event) => {
    if (
      !(event.target as HTMLElement).closest("#menu") &&
      !(event.target as HTMLElement).closest("#menu-button")
    ) {
      menuVisible.value = false;
    }
  });
});
</script>

<style>
@reference "~/assets/css/main.css";

.bg-glass {
  background-image: linear-gradient(
      100deg,
      rgb(255 255 255 / 40%) 30%,
      rgb(255 255 255/0%) 31%
    ),
    linear-gradient(
      118deg,
      rgb(255 255 255 / 85%) 60%,
      rgb(255 255 255/80%) 61%
    );
  @apply backdrop-blur-xs;
}
</style>
